import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatIconModule } from '@angular/material/icon';
import { HttpClientModule } from '@angular/common/http';
import { MatDialogModule } from '@angular/material/dialog';
import {NgApexchartsModule} from "ng-apexcharts";
import { SidenavComponent } from './sidenav/sidenav.component';
import { MatSidenavModule } from '@angular/material/sidenav';
import{ MatListModule } from '@angular/material/list';
import {MatToolbarModule} from '@angular/material/toolbar';
import { DatepickerModule } from 'ng2-datepicker';
import { SharedComponent } from './shared/shared.component';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { ProfileComponent } from './profile/profile.component';
import { CreateCustomerComponent } from './create-customer/create-customer.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { EditdriverComponent } from './editdriver/editdriver.component';
import { DltpopupComponent } from './dltpopup/dltpopup.component';
import { DltdriverpopupComponent } from './dltdriverpopup/dltdriverpopup.component';
import {
  MatSnackBarModule,
  MAT_SNACK_BAR_DEFAULT_OPTIONS,
} from '@angular/material/snack-bar';
import { MatMenuModule } from '@angular/material/menu';
import { NgxSpinnerModule } from 'ngx-spinner';

import { AgmDirectionModule } from 'agm-direction'
import { ViewDriverComponent } from './view-driver/view-driver.component';
import { NgOtpInputModule } from  'ng-otp-input';
import { ReasonCreateComponent } from './reason-create/reason-create.component';
import { ReasonEditComponent } from './reason-edit/reason-edit.component';
import { AgmCoreModule } from '@agm/core';
import { DeleteReasonComponent } from './delete-reason/delete-reason.component';
import { DeleterideComponent } from './deleteride/deleteride.component';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { EditAdminComponent } from './edit-admin/edit-admin.component';
import { DeleteAdminComponent } from './delete-admin/delete-admin.component';
import { SocketIoModule, SocketIoConfig } from 'ngx-socket-io';
import { environment } from 'src/environments/environment';
import { CoordinatesComponent } from './coordinates/coordinates.component';
import { HashLocationStrategy, LocationStrategy  } from '@angular/common';
import { DeleteGeoFencingComponent } from './delete-geo-fencing/delete-geo-fencing.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { Ng2SearchPipeModule } from 'ng2-search-filter';
import { DatePipe } from '@angular/common';
import { ViewallrideComponent } from './viewallride/viewallride.component';
import { ToastrModule } from 'ngx-toastr';
import { ViewsubadminComponent } from './viewsubadmin/viewsubadmin.component';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { ViewuserComponent } from './viewuser/viewuser.component';
import { CKEditorModule } from 'ckeditor4-angular';
import { WebcamModule } from 'ngx-webcam';
import { AgmJsMarkerClustererModule } from '@agm/js-marker-clusterer';
import { AgmDrawingModule } from '@agm/drawing';
import { EditvehicleComponent } from './editvehicle/editvehicle.component';
import { EditrideComponent } from './editride/editride.component';
import { PasswordcontentComponent } from './passwordcontent/passwordcontent.component';
import { ApiintegrationComponent } from './apiintegration/apiintegration.component';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { TermsAndConditionsComponent } from './terms-and-conditions/terms-and-conditions.component';
import { RentalsComponent } from './rentals/rentals.component';
import { CommonModuleComponent } from "./components/common-module/common-module.component";
import { ImagePreviewComponent } from './image-preview/image-preview.component';
@NgModule({
  declarations: [
    AppComponent,
    SidenavComponent,
    SharedComponent,
    ProfileComponent,
    CreateCustomerComponent,
    EditdriverComponent,
    DltpopupComponent,
    DltdriverpopupComponent,
    ViewDriverComponent,
    ReasonCreateComponent,
    ReasonEditComponent,
    DeleteReasonComponent,
    DeleterideComponent,
    EditAdminComponent,
    DeleteAdminComponent,
    CoordinatesComponent,
    DeleteGeoFencingComponent,
    ViewallrideComponent,
      ViewsubadminComponent,
      ViewuserComponent,
      EditvehicleComponent,
      EditrideComponent,
      PasswordcontentComponent,
      ApiintegrationComponent,
      PrivacyPolicyComponent,
      TermsAndConditionsComponent,
      RentalsComponent,
      ImagePreviewComponent
  ],
  imports: [
    BrowserModule,
    MatListModule,
    AgmJsMarkerClustererModule,
    MatSidenavModule,
    MatButtonToggleModule,
    AgmDrawingModule,
    NgxPaginationModule,
    NgOtpInputModule,
    NgxSpinnerModule,
    NgxIntlTelInputModule,
    MatMenuModule,
    CKEditorModule,
    WebcamModule,
    DatepickerModule,
    MatToolbarModule,
    MatIconModule,
    NgbModule,
    MatSnackBarModule,
    FormsModule,
    Ng2SearchPipeModule,
    ReactiveFormsModule,
    HttpClientModule, MatDialogModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    BsDropdownModule.forRoot(),
    NgMultiSelectDropDownModule.forRoot(),
    AgmDirectionModule,
    AgmCoreModule.forRoot({
        apiKey: 'AIzaSyBTxAcvcEmDaQWgmhm0URI-veuv0Uy-Ops',
        libraries: ['places', 'drawing', 'geometry']
    }),
    ToastrModule.forRoot({
        timeOut: 5000, // 15 seconds
    }),
    NgApexchartsModule,
    CommonModuleComponent
],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [
    DatePipe,
    {
    provide: MAT_SNACK_BAR_DEFAULT_OPTIONS,
    useValue: { panelClass: ['mycsssnackbartest'] },
  },
  {provide : LocationStrategy , useClass: HashLocationStrategy} ],
  bootstrap: [AppComponent],
})
export class AppModule {}
